import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { UsuarioContextProvider } from './contexts/UserContext';

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <UsuarioContextProvider>
                <App />
            </UsuarioContextProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
);
